import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import trustee1 from '../assets/trustee/laptop/laptrustee1.webp';
import trustee2 from '../assets/trustee/laptop/laptrustee2.webp';
import trustees1 from '../assets/trustee/mobile/current/currenttrustee1.webp';
import trustees2 from '../assets/trustee/mobile/current/currenttrustee2.webp';
import xtrustee1 from '../assets/trustee/mobile/past/pasttrustee1.webp';
import xtrustee2 from '../assets/trustee/mobile/past/pasttrustee2.webp';
import xtrustee3 from '../assets/trustee/mobile/past/pasttrustee3.webp';
import xtrustee4 from '../assets/trustee/mobile/past/pasttrustee4.webp';



// Desktop, Laptop, and Mobile images
const desktopImages = [trustee2, trustee1];
const laptopImages = [trustee2, trustee1];
const mobileImages = [trustees1, trustees2, xtrustee1, xtrustee2, xtrustee3,xtrustee4];

export default function Trustee() {
  const [isPlaying, setIsPlaying] = useState(true);
  const [screenSize, setScreenSize] = useState('desktop'); // 'desktop', 'laptop', 'mobile'
  const [slide, setSlide] = useState(0); // Used for manual navigation

  useEffect(() => {
    // Detect screen size for desktop, laptop, and mobile
    const handleResize = () => {
      if (window.innerWidth > 1440) {
        setScreenSize('desktop');
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1440) {
        setScreenSize('laptop');
      } else {
        setScreenSize('mobile');
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = () => {
    setIsPlaying(!isPlaying);
  };

  // Set images based on screen size
  const imagesToShow = screenSize === 'desktop' ? desktopImages : screenSize === 'laptop' ? laptopImages : mobileImages;

  const nextSlide = () => {
    const totalImages = imagesToShow.length;
    setSlide((prevSlide) => (prevSlide === totalImages - 1 ? 0 : prevSlide + 1));
  };

  const prevSlide = () => {
    const totalImages = imagesToShow.length;
    setSlide((prevSlide) => (prevSlide === 0 ? totalImages - 1 : prevSlide - 1));
  };

  return (
    <div>
      <div id="feedback" className="bg-gray-100">
        <div id="home" className="relative w-full h-full mx-auto overflow-hidden p-4">
          {/* Left Arrow */}
          <BsArrowLeftCircleFill
            onClick={prevSlide}
            className="absolute left-4 md:left-8 text-gray-400 text-3xl md:text-4xl cursor-pointer z-10"
            style={{ top: '50%', transform: 'translateY(-50%)' }}
          />

          <Carousel
            autoPlay={isPlaying}
            interval={5000}
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            showArrows={false}
            dynamicHeight={false}
            emulateTouch
            stopOnClick={true}
            selectedItem={slide}
            onChange={(index) => setSlide(index)} // Sync slide changes with Carousel
            renderIndicator={(clickHandler, isSelected, index, label) => {
              const className = isSelected ? 'bg-black' : 'bg-gray-400';
              return (
                <li
                  className={`inline-block w-3 h-3 mx-1 rounded-full cursor-pointer ${className}`}
                  aria-label={`Go to slide ${label} ${index + 1}`}
                  title={`Go to slide ${label} ${index + 1}`}
                  onClick={clickHandler}
                  onKeyDown={clickHandler}
                  value={index}
                  role="button"
                  tabIndex={0}
                />
              );
            }}
          >
            {imagesToShow.map((src, index) => (
              <div key={index} className="relative flex items-center justify-center h-[400px]">
                <img
                  src={src}
                  alt={`Slide ${index + 1}`}
                  className="carousel-image rounded-2xl"
                  onClick={handleImageClick}
                  style={{
                    objectFit: screenSize === 'mobile' ? 'contain' : 'cover', // Ensures the image fits properly in mobile
                    objectPosition: 'center',
                    margin: '5px',
                    borderRadius: '20px',
                  }}
                />
                {!isPlaying && (
                  <div className="absolute inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50 rounded-2xl">
                    <span className="text-white">Paused</span>
                  </div>
                )}
              </div>
            ))}
          </Carousel>

          {/* Right Arrow */}
          <BsArrowRightCircleFill
            onClick={nextSlide}
            className="absolute right-4 md:right-8 text-gray-400 text-3xl md:text-4xl cursor-pointer z-10"
            style={{ top: '50%', transform: 'translateY(-50%)' }}
          />

          <style jsx>{`
            .carousel-image {
              width: calc(100% - 10px); /* Adjusted margin for better fit */
              height: auto;
              border-radius: 20px;
              object-fit: cover; /* Ensures images fit properly */
            }

            @media (max-width: 768px) {
              .carousel-image {
                height: auto; /* Let height adjust to the content */
                width: 100%; /* Ensure the image takes up full width */
              }
            }

            @media (max-width: 480px) {
              .carousel-image {
                width: 100%; /* Take full width */
                height: auto; /* Adjust height based on image content */
                object-fit: cover; /* Contain ensures the entire image fits */
              }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}
